<ng-template #details>
  @if (controlName && questions) {
    <span [innerHtml]="getDetails()"></span>
  }
</ng-template>
<!-- [popover]="questions.popover?details:null" placement="top" triggers="mouseenter:mouseleave" -->
<!-- (blur)="onTouched()" -->
<div tabindex="-1" id="{{setId}}1"
  [ngClass]="defaultSettings.singleSelection ? 'multiselect-dropdown singleSelection' : 'multiselect-dropdown'"
  (clickOutside)="closeDropdown()">
  <div [class.disabled]="disabled"
    [popover]="questions && questions.popover && selectedItems.length >0 && getPopOverDetails()?details:null" placement="right"
    triggers="mouseenter:mouseleave" #pop="bs-popover" [outsideClick]="true" containerClass="info-popover">
    <span [attr.tabindex]="custom?0:-1" class="dropdown-btn multiselect-dropdown-click"
        [ngClass]="{
            'focuscheck': custom,
            'facility-search': _settings.hasAppliedCss,
            'show-Multi': !_settings.hasAppliedCss && _settings.defaultOpen
          }"
      (click)="toggleDropdown($event)" (keydown.arrowdown)="custom && toggleDropdown($event)"
      >
      <i [ngClass]="_settings.location_icon != undefined? _settings.location_icon:''" aria-hidden="true"></i>
      @if (selectedItems.length == 0) {
        <span
        [ngClass]="_settings.hasAppliedCss?'place-holder-text':''">{{_placeholder | translate | async}}</span>
      }
      @if (selectedItems.length > 0) {
        @for (item of selectedItems; track trackByFn(k, item); let k = $index) {
          <!-- *ngIf="format == undefined"  -->
          <span [ngClass]="_settings.hasAppliedCss?'':'selected-item'"
            [hidden]="k > _settings.itemsShowLimit-1">
            @if ((_settings && _settings.flag!=undefined && _settings.flag) || item.isNonFormulary) {
              <app-flags
                [config]="{item:item,setting:questions.flag,flag_only:true}">
              </app-flags>
            }
            {{getItem(item)}}
            @if (!_settings.hasAppliedCss) {
              <a class="pill-action" (click)="onItemClick(item,k,$event)"><i
              class="fa fa-times" aria-hidden="true"></i></a>
            }
          </span>
          <!-- <span class="selected-item"  id="bed1" *ngIf="format != undefined"
          [hidden]="k > _settings.itemsShowLimit-1">
          {{getValue(item.mixdata, format)}}
          <a style="padding-top:2px;padding-left:2px;color:white" (click)="onItemClick($event,item)">x</a>
        </span> -->
      }
    }
    <span class="multi-select-count">
      @if (itemShowRemaining()>0) {
        <span>+{{itemShowRemaining()}}</span>
      }
      <!-- <span [ngClass]="_settings.defaultOpen ? 'dropdown-up' : 'dropdown-down'"></span> -->
    </span>
  </span>
</div>
<div class="dropdown-list" [hidden]="!_settings.defaultOpen"
  [ngClass]="[_settings.hasAppliedCss?'facility-searchlist':'',greaterHeight?'upperSide':'']">
  <ul class="item1">
    <!-- && _settings.limitSelection === 1 Remomved beacause of some issue in enableCheckAll case in case of update-->
    @if (_data.length > 0 && !_settings.singleSelection && _settings.enableCheckAll && !disabled) {
      <li (click)="toggleSelectAll()"
        class="multiselect-item-checkbox d-flex" style="border-bottom: 1px solid #ccc;padding:10px">
        @if (_settings.checkBoxRequired) {
          <input type="checkbox" aria-label="multiselect-select-all" autocomplete="off"
            [checked]="isAllItemsSelected()" [disabled]="disabled || isLimitSelectionReached()" />
        }
        <div>{{!isAllItemsSelected() ? _settings.selectAllText : _settings.unSelectAllText}}</div>
      </li>
    }
    @if (_settings.allowSearchFilter && selectedItems.length > 0) {
      <li class="filter-textbox">
        @if (hasComplexSearch()) {
          @if (selectedSearchField) {
            <span class="complex-search-pill">
              <span class="selected-pill-item">{{selectedSearchField.label | translate | async}}
                @if (complexSearchFields.length > 1) {
                  <a class="complex-search-pill-close"
                    (click)="toggleComplexSearchPopup($event)">
                    <i class="fa fa-angle-down"></i>
                  </a>
                }
              </span>
            </span>
          }
          @if (showComplexSearchPopup) {
            <div class="complex-search-container">
              <div class="complex-search-body">
                @for (field of complexSearchFields; track field) {
                  <button type="button" class="p-dropdown-item"
                    (click)="onComplexSearchFieldSelected(field, $event)">
                    {{field.label | translate | async}}
                  </button>
                }
              </div>
            </div>
          }
        }
        <span class="dropdown-btn" [ngClass]="{'h-100':defaultSettings.isMinHeight == false}"
          style="border:none;" (click)="defaultSettings.isMinHeight = !defaultSettings.isMinHeight">
          @for (item of selectedItems; track trackByFn(k, item); let k = $index) {
            <span [ngClass]="_settings.hasAppliedCss?'':'selected-item'">
              {{getItem(item)}}
              @if (!_settings.hasAppliedCss) {
                <a class="pill-action"
                  (click)="onItemClick(item,k,$event)"><i class="fa fa-times" aria-hidden="true"></i></a>
                }
              </span>
            }
          </span>
        </li>
      }
      @if (_settings.allowSearchFilter && !disabled) {
        <li class="filter-textbox">
          @if (hasComplexSearch()) {
            @if (selectedSearchField) {
              <span class="complex-search-pill">
                <span class="selected-pill-item">{{selectedSearchField.label | translate | async}}
                  @if (complexSearchFields.length > 1) {
                    <a class="complex-search-pill-close"
                      (click)="toggleComplexSearchPopup($event)">
                      <i class="fa fa-angle-down"></i>
                    </a>
                  }
                </span>
              </span>
            }
            @if (showComplexSearchPopup) {
              <div class="complex-search-container">
                <div class="complex-search-body">
                  @for (field of complexSearchFields; track field) {
                    <button type="button" class="p-dropdown-item"
                      (click)="onComplexSearchFieldSelected(field, $event)">
                      {{field.label | translate | async}}
                    </button>
                  }
                </div>
              </div>
            }
          }
          @if (_settings.apliCall) {
            <input tabindex="0" type="text" aria-label="multiselect-search"
              [readOnly]="disabled" [id]="questions.key?questions.key:'dynamic_field'" [attr.data-speech-key]="questions.key?questions.key:'dynamic_field'" autocomplete="off"
              [placeholder]="_settings.onEnterSearch?'Press enter for search result':_settings.searchPlaceholderText"
              [(ngModel)]="dataFromApiModel" (ngModelChange)="changeDataBasedModel($event)"
              class="filter-textbox-input" (keydown.enter)="$event.preventDefault()">
          }
          @if (!_settings.apliCall) {
            <input tabindex="0" class="filter-textbox-input"
              [id]="questions.key?questions.key:'dynamic_field'" [attr.data-speech-key]="questions.key?questions.key:'dynamic_field'" type="text" aria-label="multiselect-search"
              [readOnly]="disabled" [placeholder]="_settings.searchPlaceholderText" [(ngModel)]="filter.text" autocomplete="off"
              (ngModelChange)="onFilterTextChange($event)" (keydown.enter)="$event.preventDefault()"
              (keydown.enter)="$event.preventDefault()"
              (keydown.arrowdown)="custom&&$event.preventDefault(); custom && availableOptions?.first?.nativeElement?.focus(); ">
          }
          @if (_settings!=undefined && _settings.advancesearch!=undefined && _settings.advancesearch && _settings.advancesearch.icd_search != undefined && _settings.advancesearch.icd_search) {
            <span class="custom-control custom-switch toggle-icd mr-3 p-0 table-switch"
              (click)="toggleIcd();">
              <input class="custom-control-input" type="checkbox"  autocomplete="off" [checked]=icd_enable>
              <label class="custom-control-label">
              </label>
              <p class="m-0 p-0">WHO</p>
            </span>
          }
          @if (_settings!=undefined && _settings.advancesearch!=undefined && _settings.advancesearch) {
            <span
              class="advsearchspan"
              (click)="openAdvSearch(_settings.advancesearch.resource,_settings.advancesearch.datasource!=undefined && _settings.advancesearch.datasource?_settings.advancesearch.datasource:'');"><i
            aria-hidden="true" class="fa fa-sliders"></i> </span>
          }
          @if (prefereceService.checkCommonConfigEnabled('voice_search')) {
            <span class="advsearchspan _voice_search"
              (click)="textToSpeech(questions.key?questions.key:'dynamic_field')"><i aria-hidden="true"
            class="fa fa-microphone"></i> </span>
          }
        </li>
      }
      @if (_settings.filter && _settings.filter.length > 0) {
        <li class="filter-textbox clinic-rdio-align">
          <div class="radio-action-container">
            <div class="radio-containers d-flex flex-wrap">
              @for (fl of _settings.filter; track fl) {
                <label class="radio-wrapper">{{fl.name}}
                  <input type="radio" name="basedOn" (change)="changeFilterSet(fl.filter_set)" autocomplete="off">
                  <span class="check-mark-radio"></span>
                </label>
              }
            </div>
          </div>
        </li>
      }
    </ul>
    @if (!isLoading && !disabled) {
      <ul tabindex="0" (keydown.arrowdown)="handleKeyEvent($event,true)" (keydown.arrowup)="handleKeyEvent($event,false)"
        (keydown.Tab)="closeDropdown()" class="item2 scroller dropdown-list-item-container"
        [style.maxHeight]="_settings.maxHeight+'px'">
        @for (item of _data | sortData:questions | multiSelectFilter:filter; track item; let i = $index) {
          <li #availableOption
            tabindex="-1"
            (keyup.enter)="onItemClick(item,i,$event)" (click)="onItemClick(item,i,$event)"
            [class.focus_li_multiselect]="focusedStatus"
            [ngClass]="item.id == 0?'multiselect-item-checkbox-withoutHover d-flex':'multiselect-item-checkbox'">
            <div class="d-flex">
              <div><i [ngClass]="_settings.location_icon != undefined? _settings.location_icon:''"
              aria-hidden="true"></i></div>
              <div>
                @if (_settings.checkBoxRequired && _data[0].text != _settings.noDataAvailablePlaceholderText ) {
                  <input
                    type="checkbox" aria-label="multi-select-item-inp" class="multi-select-item-inp"
                    [checked]="isSelected(item)" autocomplete="off"
                    [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled" />
                }
                <div class="d-flex">
                  @if (((_settings.flag!=undefined && _settings.flag) || item.isNonFormulary) && _data[0].text != _settings.noDataAvailablePlaceholderText) {
                    <app-flags
                      [config]="{item:item,setting:questions.flag,flag_only:true}">
                    </app-flags>
                  }
                  <!-- dropdown values without class condition -->
                  @if (!questions.class_conditions) {
                    @if (format == undefined) {
                      <div class="text-wrap" style="line-height: 20px;">
                      {{getItem(item)}}</div>
                    }
                    @if (format != undefined && item.id != '0') {
                      <div>
                        {{item.mixdata!=undefined?getValue(item.mixdata, format):getValue(item, format)}}
                      </div>
                    }
                    @if (format != undefined && item.id == '0') {
                      <div style="cursor: not-allowed;">
                      {{item.text}}</div>
                    }
                  }
                  <!-- dropdown values with class condition -->
                  @if (questions.class_conditions) {
                    @if (format == undefined) {
                      <div
                        [ngClass]="(item.mixdata!=undefined?item.mixdata:item) | getClass: questions.class_conditions">
                      {{getItem(item)}}</div>
                    }
                    @if (format != undefined && item.id != '0') {
                      <div
                        [ngClass]="(item.mixdata!=undefined?item.mixdata:item) | getClass: questions.class_conditions">
                        {{item.mixdata!=undefined?getValue(item.mixdata, format):getValue(item, format)}}
                      </div>
                    }
                    @if (format != undefined && item.id == '0') {
                      <div style="cursor: not-allowed;"
                        [ngClass]="(item.mixdata!=undefined?item.mixdata:item) | getClass: questions.class_conditions">
                      {{item.text}}</div>
                    }
                  }
                </div>
                @if (_settings.flag!=undefined && _settings.flag && _data[0].text != _settings.noDataAvailablePlaceholderText) {
                  <div
                    class="ng-star-inserted" style="width:100%;display: block;" class="flagText">
                    {{(item.mixdata!=undefined?item.mixdata:item) | getClass:
                    questions.flag.conditions:"text_true"}}
                  </div>
                }
                @if (_settings.flag!=undefined && _settings.flag && _data[0].text != _settings.noDataAvailablePlaceholderText &&
                !((item.mixdata!=undefined?item.mixdata:item) | getClass:questions.flag.conditions:'text_true')) {
                <div class="ng-star-inserted" style="width:100%;display: block;" class="flagText">
                  {{getFlagText(item)}}
                </div>
                }
              </div>
            </div>
          </li>
        }
        @if (!defaultSettings.free_text_with_data && _data.length == 0 || (_data | sortData:questions |  multiSelectFilter:filter)?.length == 0) {
          <li class='no-data'
            >
            <div style="text-align: center;">
              @if (defaultSettings.hit_search) {
                <p>{{'field.label.no_data_found' | translate | async}} &nbsp;
                  &nbsp;
                  <i class="fa fa-refresh" style="color: blue;" aria-hidden="true"
                  (click)="noDataFoundSearchAgain($event)"></i>
                  <!-- <span><a style="cursor: pointer; color: blue;">Clear all</a></span> -->
                </p>
              }
              @if (!defaultSettings.hit_search) {
                <p> {{ transaltedCustomDataNotFoundMessage && transaltedCustomDataNotFoundMessage.trim()
                  ? transaltedCustomDataNotFoundMessage
                : ('type_to_search' | translate | async) }}</p>
              }
              @if (defaultSettings.freeText && (dataFromApiModel != '' || filter.text != '') && defaultSettings.configFreeText) {
                <p
                  >
                  {{(_settings.apliCall) ? dataFromApiModel : filter.text}} <i class="fa fa-plus"
                  style="color: blue;" aria-hidden="true"
                (click)="addFreeText((_settings.apliCall) ? dataFromApiModel : filter.text)"></i>
              </p>
            }
          </div>
        </li>
      }
      @if (defaultSettings.free_text_with_data) {
        <li class='no-data'
          >
          <div style="text-align: center;">
            @if (_data.length == 0 || (_data | sortData:questions |  multiSelectFilter:filter)?.length == 0) {
              @if (defaultSettings.hit_search) {
                <p>{{'field.label.no_data_found' | translate | async}} &nbsp;
                  &nbsp;
                  <i class="fa fa-refresh" style="color: blue;" aria-hidden="true"
                  (click)="noDataFoundSearchAgain($event)"></i>
                </p>
              }
              @if (!defaultSettings.hit_search) {
                <p>{{'type_to_search' | translate | async}}</p>
              }
            }
            @if (defaultSettings.freeText && (dataFromApiModel != '' || filter.text != '') && defaultSettings.configFreeText) {
              <p>
                {{(_settings.apliCall) ? dataFromApiModel : filter.text}} <i class="fa fa-plus"
                style="color: blue;" aria-hidden="true"
              (click)="addFreeText((_settings.apliCall) ? dataFromApiModel : filter.text)"></i>
            </p>
          }
        </div>
      </li>
    }
  </ul>
}

@if (showMoreObj && showMoreObj.hasMoreData && !disabled) {
<div class="show-more-fixed" (click)="loadMoreData(); $event.stopPropagation()">
  <!-- When more data available -->
  @if (!showMoreObj.isLoadingMore) {
  <span>Show More</span>
  }
  <!-- When api not getting data/any err coming -->
  @if (showMoreObj.noMoreData) {
  <span>No More Data Found</span>
  }
  <!-- while loading -->
  @if (showMoreObj.isLoadingMore) {
  <span>Loading...</span>
  }
</div>
}
@if (isLoading) {
  <ul class="item2" [style.maxHeight]="'60px'">
    <li>
      @if (isLoading) {
        <div class="text-center">
          <div class="spinner-border text-info text-center"></div>
        </div>
      }
    </li>
  </ul>
}
@if (_settings.textSearch && rolePermission.checkIfEnabled('text_search')) {
  <span class="advsearchspan atlasSearch mr-4">
    <input (change)="prefereceService.saveCommonConfig('text_search',$event.currentTarget.checked);changeTextSearch($event.currentTarget.checked)"
      [checked]="prefereceService.checkCommonConfigEnabled('text_search')" type="checkbox" autocomplete="off"
      title="Enable Text Search" style="width: 15px;height: 15px;">
  </span>
}
</div>
</div>